import Item from "./Item";
import { db } from '../config/firebase'
import { collection, doc, getDocs } from 'firebase/firestore'
import { useEffect, useState } from "react";

const Container = () => {
    const [ data, setData ] = useState([])

    // function to shuffle the array
    function shuffle(arr) {
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
    }

    // const x = [1, 2, 3, 4, 5]

    // console.log(baseUrl)
    const dataCollectionRef = collection(db, "lost-link")

    useEffect(() => {
        const getData = async () => {
            const res = await getDocs(dataCollectionRef)
            setData(res.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
            // console.log(data)
        }


        // shuffle(x)
        // console.log(x)
        getData()
    }, [])

    const shuffledData = shuffle([...data])

    return <section id="container" className="w-[95vw] mx-auto py-10 px-2 my-5 flex flex-wrap gap-5 justify-center">
            {
                shuffledData.map((item) => {
                    return <Item path={item.link} key={Math.floor(Math.random() * 2000)} />
                })
            }
    </section>
}

export default Container;